@if (parentTitle$ | async; as parentTitle) {
  <sh-list-row-title [title]="parentTitle" [navigationLink]="parentNavigationLink$ | async"></sh-list-row-title>
}
